import React from 'react';
import CartModal from '..';

const CartModalCheckoutFlow: React.FC = (props) => <CartModal mobileCheckoutMode {...props} />;
export default CartModalCheckoutFlow;
